class Format {
  /**
   * Returns a number in Indian numbering system as a String
   *
   * @param {Number/String} number The integer to be converted.
   * @deprecated use `inr` from `utils/formatters.utils` instead
   */
  static currency(number: number) {
    if (number / 1000 > 1) {
      return number.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      })
    }
    return number
  }

  static variety(variety?: any) {
    return variety?.id
      ? `${variety?.commodity?.name} - (${variety?.name})`
      : "Na"
  }

  //  10:00:00 -> 10 hrs 0 mins 0 secs
  static time(time?: string) {
    const parsedTime = time?.split(":").map(a => parseInt(a))

    return parsedTime?.reduce((prev: any, num: any, idx) => {
      if (!num) return prev
      switch (idx) {
        case 0:
          return prev + `${num} hrs `
        case 1:
          return prev + `${num} mins `
        case 2:
          return prev + `${num} sec`
        default:
          return null
      }
    }, " ")
  }

  static distance(value?: number) {
    if (!value || typeof value !== "number") return "na"
    return value.toLocaleString("en-In", {
      style: "unit",
      unit: "kilometer",
      unitDisplay: "short",
      maximumFractionDigits: 1,
    })
  }

  static secondsToHoursAndMinutes(value?: number) {
    const hours = Math.floor(value / 3600)
    const minutes = Math.floor((value % 3600) / 60)
    return `${hours}hrs ${minutes}mins`
  }
  static addItemToAlinkedList() {}
}

export default Format
